import React from "react";
import "./styles.scss";
import shopifyImg from "./Shopify.svg";
import commerceImg from "./Commerce.svg";
import shopwareImg from "./shopware.svg";

function HomePlatformPartners() {
	return (
		<div className="platform-partners">
			<h2 className="platform-partners__heading">Our Platform Partners</h2>
			<div className="platform-partners__partner-list">
				<a
					href="https://www.shopify.com/plus"
					className="platform-partners__partner"
					target="_blank"
					rel="noreferrer"
				>
					<img src={shopifyImg} alt="Shopify" />
				</a>
				<a
					href="https://www.bigcommerce.com/"
					className="platform-partners__partner"
					target="_blank"
					rel="noreferrer"
				>
					<img src={commerceImg} alt="Commerce" />
				</a>
				<a
					href="https://www.shopware.com/en/?utm_source=irishtitan&utm_medium=partner&utm_campaign=integration-partner-us&utm_content=partner_website"
					className="platform-partners__partner"
					target="_blank"
					rel="noreferrer"
				>
					<img src={shopwareImg} alt="Shopware" />
				</a>
			</div>
		</div>
	);
}

export default HomePlatformPartners;
